module.exports = __webpack_public_path__ + "img/hotels-and-accommodation-icon.9883cd4e.svg";